import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  background-color: ${(props) => props.theme.color.background.primary};
  box-shadow: 0 8px 20px #1e1d2a;
  border-radius: 12px;
`;

const CollapsedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CollapsedIcon = styled.img`
  margin: 12px 12px 12px 24px;
  width: 40px;
  height: 40px;
`;

const Collapsed = (props) => {
  return (
    <CollapsedContainer onClick={props.onClick}>
      <CollapsedIcon src={props.icon} style={{ margin: "12px" }} />
    </CollapsedContainer>
  );
};

export { Container, Collapsed };
